import React, { useState, useEffect, useRef } from "react";
import TextField from "@mui/material/TextField";

import Button from "@mui/material/Button";

import { ReactSearchAutocomplete } from "react-search-autocomplete";

import { useDialog } from "react-st-modal";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import NotificationSystem from "react-notification-system";
import AlertResponse from "../../main_components/alerts/alertResponse";
import { catchErrorModul } from "../../main_components/catchErr/catchError";
import { refresh_token } from "../../main_components/tokens/tokenrefresh";
import { get_route } from "../../services/configuration/configuration";
import { get_employess, put_drivers } from "../../services/humanResources/humanResources";

const ValidationTextField = styled(TextField)({
  "& input:valid + fieldset": { borderColor: "black", borderWidth: 1 },
  "& input:valid:focus + fieldset": {
    borderLeftWidth: 6,
    padding: "4px !important",
  },
});
const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;base64,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')`,
      },
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "white" : "white",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4Igp3aWR0aD0iMjAiIGhlaWdodD0iMjAiCnZpZXdCb3g9IjAgMCA1MCA1MCIKc3R5bGU9ImZpbGw6IzQwQzA1NzsiPgo8cGF0aCBkPSJNIDIyLjc4MTI1IDAgQyAyMS42MDU0NjkgLTAuMDAzOTA2MjUgMjAuNDA2MjUgMC4xNjQwNjMgMTkuMjE4NzUgMC41MzEyNSBDIDEyLjkwMjM0NCAyLjQ5MjE4OCA5LjI4OTA2MyA5LjI2OTUzMSAxMS4yNSAxNS41OTM3NSBMIDExLjI1IDE1LjY1NjI1IEMgMTEuNTA3ODEzIDE2LjM2NzE4OCAxMi4xOTkyMTkgMTguNjE3MTg4IDEyLjYyNSAyMCBMIDkgMjAgQyA3LjMwMDc4MSAyMCA2IDIxLjMwMDc4MSA2IDIzIEwgNiA0NyBDIDYgNDguNjk5MjE5IDcuMzAwNzgxIDUwIDkgNTAgTCA0MSA1MCBDIDQyLjY5OTIxOSA1MCA0NCA0OC42OTkyMTkgNDQgNDcgTCA0NCAyMyBDIDQ0IDIxLjMwMDc4MSA0Mi42OTkyMTkgMjAgNDEgMjAgTCAxNC43NSAyMCBDIDE0LjQ0MTQwNiAxOS4wMDc4MTMgMTMuNTExNzE5IDE2LjA3NDIxOSAxMy4xMjUgMTUgTCAxMy4xNTYyNSAxNSBDIDExLjUxOTUzMSA5LjcyMjY1NiAxNC41IDQuMTA5Mzc1IDE5Ljc4MTI1IDIuNDY4NzUgQyAyNS4wNTA3ODEgMC44MzIwMzEgMzAuNjk1MzEzIDMuNzk2ODc1IDMyLjM0Mzc1IDkuMDYyNSBDIDMyLjM0Mzc1IDkuMDY2NDA2IDMyLjM0Mzc1IDkuMDg5ODQ0IDMyLjM0Mzc1IDkuMDkzNzUgQyAzMi41NzAzMTMgOS44ODY3MTkgMzMuNjU2MjUgMTMuNDA2MjUgMzMuNjU2MjUgMTMuNDA2MjUgQyAzMy43NDYwOTQgMTMuNzY1NjI1IDM0LjAyNzM0NCAxNC4wNTA3ODEgMzQuMzg2NzE5IDE0LjEzNjcxOSBDIDM0Ljc1IDE0LjIyNjU2MyAzNS4xMjg5MDYgMTQuMTA5Mzc1IDM1LjM3NSAxMy44MzIwMzEgQyAzNS42MjEwOTQgMTMuNTUwNzgxIDM1LjY5NTMxMyAxMy4xNjAxNTYgMzUuNTYyNSAxMi44MTI1IEMgMzUuNTYyNSAxMi44MTI1IDM0LjQzMzU5NCA5LjE3MTg3NSAzNC4yNSA4LjUzMTI1IEwgMzQuMjUgOC41IEMgMzIuNzgxMjUgMy43NjE3MTkgMjguNjAxNTYzIDAuNTQyOTY5IDIzLjkzNzUgMC4wNjI1IEMgMjMuNTUwNzgxIDAuMDIzNDM3NSAyMy4xNzE4NzUgMCAyMi43ODEyNSAwIFogTSAyNSAzMCBDIDI2LjY5OTIxOSAzMCAyOCAzMS4zMDA3ODEgMjggMzMgQyAyOCAzMy44OTg0MzggMjcuNjAxNTYzIDM0LjY4NzUgMjcgMzUuMTg3NSBMIDI3IDM4IEMgMjcgMzkuMTAxNTYzIDI2LjEwMTU2MyA0MCAyNSA0MCBDIDIzLjg5ODQzOCA0MCAyMyAzOS4xMDE1NjMgMjMgMzggTCAyMyAzNS4xODc1IEMgMjIuMzk4NDM4IDM0LjY4NzUgMjIgMzMuODk4NDM4IDIyIDMzIEMgMjIgMzEuMzAwNzgxIDIzLjMwMDc4MSAzMCAyNSAzMCBaIj48L3BhdGg+Cjwvc3ZnPg==')`,
    },
  },
  "& .MuiSwitch-track": {
    backgroundColor: theme.palette.mode === "dark" ? "white" : "white",
    borderRadius: 20 / 2,
  },
}));

const Put_driver = ({License_num,Num_reg_id_trib,Id,Rfc,Transport_parts,Fiscal_residence,Type,Ruta,Driver_name}) => {


  const [type, settype] = React.useState(Type);
  const [license_num, setlicense_num] = React.useState(License_num);
  const [num_reg_id_trib, setnum_reg_id_trib] = React.useState(Num_reg_id_trib);
  const [fiscal_residence, setfiscal_residence] = React.useState(Fiscal_residence);
  const [transport_parts, settransport_parts] = React.useState(Transport_parts);
  const [id_employee_fk, setid_employee_fk] = React.useState(Id);
  const [rfc, setrfc] = React.useState(Rfc);

  const [id_route_fk, setid_route_fk] = React.useState(Ruta);
  
  const dialog = useDialog();
  const [modalT, setmodalT] = useState(false);
  const [routes, setroutes] = useState([]);
  const [employeesP, setemployeesP] = useState([]);

  const [checkedGeneral, setcheckedGeneral] = React.useState(true);

  const [Busnes, setBusnes] = React.useState();

  const notificationSystemRef = useRef();

  const handletype = (event) => {
    settype(event.target.value.toUpperCase());
  };
  const handlelicense_num = (event) => {
    setlicense_num(event.target.value.toUpperCase());
  };
  const handlenum_reg_id_trib = (event) => {
    setnum_reg_id_trib(event.target.value.toUpperCase());
  };
  const handlefiscal_residence = (event) => {
    setfiscal_residence(event.target.value.toUpperCase());
  };
  const handletransport_parts = (event) => {
    settransport_parts(event.target.value.toUpperCase());
  };

  const handleid_route_fk = (event) => {
    setid_route_fk(event.target.value.toUpperCase());
  };

  const handlechecked = (event) => {
    setcheckedGeneral(event.target.checked);
    console.log(event.target.checked);
  };

  const handleOnSearch = (string, results) => {};

  const handleOnHover = (result) => {};

  const handleOnSelect = (item) => {
    setBusnes(item);
    setid_employee_fk(item.id);

    if(item.rfc===undefined){
      setrfc("");
    }else if(item.rfc===null){
      setrfc("");
    }else{
      setrfc(item?.rfc);
    }
  };

  const handleOnFocus = () => {
    console.log("Focused");
  };

  const handleOnClear = () => {
    console.log("Cleared");
  };


  var data1 = {
    driver: {
      type: type,

      license_num: license_num,

      num_reg_id_trib: checkedGeneral === true ? null : num_reg_id_trib,

      fiscal_residence: checkedGeneral === true ? null : fiscal_residence,

      transport_parts: checkedGeneral === true ? null : transport_parts,

      id_employee_fk: id_employee_fk,

      id_route_fk: id_route_fk,
    },
  };

  console.log(data1);
  async function handleSubmit(event) {
    event.preventDefault();

    setmodalT(true);

    var data = {
      driver: {
        driver_type: type,
  
        license_num: license_num,
  
        num_reg_id_trib: checkedGeneral === true ? null : num_reg_id_trib,
  
        fiscal_residence: checkedGeneral === true ? null : fiscal_residence,
  
        transport_parts: checkedGeneral === true ? null : transport_parts,
  
        id_employee_fk: id_employee_fk,
  
        id_route_fk: id_route_fk,
      },
    };
    try{
      var rf_token = await refresh_token();
      if(rf_token===true){
        setTimeout(async() => {
          try{
            const d = await put_drivers(Id, data);
            console.log("RESPONSE RECEIVED: ", d);
            setmodalT(false);
            dialog.close(true);
          }catch(err){
            catchErrorModul("Conductores", JSON.stringify(data), JSON.stringify(err?.response===undefined?"Token expirado":err?.response));
            var errroM = err?.response?.data?.message;
            notificationSystemRef.current.addNotification({
              message: (
                <AlertResponse
                  msj={
                    errroM === undefined
                      ? "Error 401:No autorizado intentelo nuevamente o recarge la pagina nuevamente oprimiendo la tecla 'CTRL + F5'"
                      : errroM
                  }
                  view={false}
                ></AlertResponse>
              ),
              level: "error",
              position: "br",
              autoDismiss: 60,
            });
            setmodalT(false);
          }
        }, 1000);
      }else{}
    }catch(err){
      console.log(err);
    }
  }

  const handlerute = async(event) => {
    event?.preventDefault();
    try {
      var rf_token = await refresh_token();
      if(rf_token===true){
        setTimeout(async() => {
          try{
            const d = await get_route();
            const data = d===null? [] : d.data.routes;
            setroutes(data);
          }catch(err){
            setroutes([]);
          }
        }, 1000);
      }else{}
    } catch (err) {
      console.log(err);
    }
};

  const handleEmployees = async (event) => {
    event?.preventDefault();
    try{
      var rf_token=await refresh_token();
      if(rf_token===true){
        setTimeout(async() => {
          try{
            const d = await get_employess();
            const data = d===null?[]: d.data;
            const nEmployes = data.map((num, index) => {
              var ndata = {
                fullname:
                  num?.name +
                  " " +
                  num?.first_last_name +
                  " " +
                  num?.second_last_name,
                id: num.id,
                rfc: num.rfc,
              };
              return ndata;
            });
            console.log(nEmployes);
            setemployeesP(nEmployes);
          }catch(err){
            setemployeesP([]);
          }
        }, 1000);
      }else{}
    }catch(err){
      console.log(err);
    }
  };

  useEffect(() => {
    handlerute();
    handleEmployees();
  }, []);

  return (
    <div className="">
      <NotificationSystem ref={notificationSystemRef} />

      <br></br>
      <div>
        <div className="containerDrivers">
          <div className="bp-1">
            <ValidationTextField
              label="Tipo "
              placeholder="Tipo"
              inputProps={{ maxLength: 5 }}
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              value={type}
              onChange={handletype}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className="bp-7">
            <ValidationTextField
              label="Número de licencia"
              required
              placeholder="Número de licencia"
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              defaultValue="Success"
              value={license_num}
              onChange={handlelicense_num}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div
            className="bp-2"
            style={{ display: checkedGeneral === true ? "none" : "" }}
          >
            <ValidationTextField
              label="num_reg_id_trib "
              required
              placeholder="num_reg_id_trib"
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              defaultValue="Success"
              inputProps={{ maxLength: 16 }}
              value={num_reg_id_trib}
              onChange={handlenum_reg_id_trib}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div
            className="bp-3"
            style={{ display: checkedGeneral === true ? "none" : "" }}
          >
            <ValidationTextField
              label="Piezas de transporte "
              required
              placeholder="Piezas de transporte"
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              defaultValue="Success"
              inputProps={{ maxLength: 40 }}
              value={transport_parts}
              onChange={handletransport_parts}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div
            className="bp-4"
            style={{ display: checkedGeneral === true ? "none" : "" }}
          >
            <ValidationTextField
              label="Residencia Fiscal "
              required
              placeholder="Residencia Fiscal"
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              defaultValue="Success"
              value={fiscal_residence}
              onChange={handlefiscal_residence}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div className="bp-5-1">
            <ReactSearchAutocomplete
              items={employeesP}
              fuseOptions={{ keys: ["fullname"] }}
              resultStringKeyName="fullname"
              onSearch={handleOnSearch}
              onHover={handleOnHover}
              onSelect={handleOnSelect}
              onFocus={handleOnFocus}
              onClear={handleOnClear}
              showIcon={true}
              placeholder={Driver_name}
              styling={{
                height: "34px",
                border: "1px solid darkgreen",
                borderRadius: "4px",
                backgroundColor: "white",
                boxShadow: "none",
                hoverBackgroundColor: "lightgreen",
                color: "black",
                iconColor: "black",
                lineColor: "black",
                placeholderColor: "black",
                clearIconMargin: "3px 8px 0 0",
                zIndex: 10,
              }}
            />
          </div>

          <div className="bp-6">
            <TextField
              select
              child
              label="Ruta"
              value={id_route_fk}
              sx={{ m: 1.5, width: "100%" }}
              onChange={handleid_route_fk}
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                native: true,
              }}
            >
              {routes?.map((option) => (
                <option key={option.id} value={option.id} selected={option.id}>
                  {option.route}
                </option>
              ))}
            </TextField>
          </div>

          <div className="bp-8">
            <FormControlLabel
              control={
                <MaterialUISwitch
                  sx={{ m: 1 }}
                  onChange={handlechecked}
                  checked={checkedGeneral}
                />
              }
              label={
                checkedGeneral === true ? "Datos extra" : "Ocultar datos extra"
              }
            />
          </div>

          <div className="bp-9">
            <ValidationTextField
              label="RFC "
              required
              placeholder="RFC"
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              value={rfc}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div className="bp-8">
            <FormControlLabel
              control={
                <MaterialUISwitch
                  sx={{ m: 1 }}
                  onChange={handlechecked}
                  checked={checkedGeneral}
                />
              }
              label={
                checkedGeneral === true ? "Datos extra" : "Ocultar datos extra"
              }
            />
          </div>

          <div className="bp-21">
            <Button
              onClick={handleSubmit}
              sx={{ m: 2, width: "100%" }}
              variant="contained"
              style={{ background: "green" }}
            >
              GUARDAR
            </Button>
          </div>

          <div className="bp-22">
            <Button
              onClick={() => {
                dialog.close();
              }}
              sx={{ m: 2, width: "100%" }}
              variant="contained"
              style={{ background: "red" }}
            >
              CANCELAR
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Put_driver;
